import { RolesEnum } from '../api-client/generated';

export const ROLES = {
  ADMINISTRATOR: RolesEnum.Administrator,
  BUSINESS_DEVELOPMENT: RolesEnum.BusinessDevelopment,
  CLIENT: 'Client',
  CUSTOMER: 'Client',
  FINANCE: '',
  OPERATIONS: RolesEnum.Operations,
  SALES: RolesEnum.Sales,
  SUPER_USER: RolesEnum.SuperUser,
  SUPERVISOR: RolesEnum.Supervisor,
  TECHNICIAN: RolesEnum.Technician
};

export default {
  ROLES
};

export const priorityRoleLogin = (
  roles: Array<String>,
  needAdmin: boolean = false
) => {
  if (needAdmin && roles.includes(ROLES.ADMINISTRATOR)) {
    return [ROLES.ADMINISTRATOR];
  }
  if (roles.includes(ROLES.TECHNICIAN)) {
    return [ROLES.TECHNICIAN];
  }
  // On mobile, Supervisor takes priority over all other roles (Operations,
  // Sales, Finance, etc). Supervisor cannot coexist with Technician so that
  // check above already covers the only invalid combination.
  if (
    roles.includes(ROLES.SUPERVISOR) &&
    /Mobi|Android|iPhone|iPad/i.test(
      typeof navigator !== 'undefined' ? navigator.userAgent : ''
    )
  ) {
    return [ROLES.SUPERVISOR];
  }
  if (roles.includes(ROLES.OPERATIONS)) {
    return [ROLES.OPERATIONS];
  }
  return roles[0];
};
